<template>
  <v-dialog v-if="!no_data.includes(text)" v-model="dialog" max-width="500px" persistent>
      <v-card class="pa-3">
          <!-- <v-card-title>
            <h2 class="title">You do not have access to this section</h2>
          </v-card-title> -->

          <v-card-text class="mt-5">
              <div>
                <v-layout class="wrap">
                <v-alert
                  outlined
                  color="info"
                  icon="mdi-information"
                  style="width: 100%;"
                  class="mb-0"
                >
                  <span class="default-text body-2" v-html="text"></span>
                </v-alert>
                </v-layout>
            </div>
          </v-card-text>

          <v-card-actions class="px-6">
              <v-spacer></v-spacer>
              <v-btn 
                color="info"
                @click="dialog = false"
              >Ok
              </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>  

<script>
import ApiService from "@/common/api.service";

export default {
  name: 'PermissionDialog',
  data: () => ({
    no_data: [null, "", undefined, "null"],
    text: null,
    dialog: false,
  }),
  mounted () {
    this.$root.$on('PermissionDialog', this.openModal)
  },
  beforeDestroy () {
    this.$root.$off('PermissionDialog', this.openModal)
  },
  methods: {
    openModal (inputData) {
      let text = inputData
      this.text = `You do not have access to the ${text}. Please email us at <a class="info--text" href="mailto:info@concretedecor.net">info@concretedecor.net</a> for more information about how you can be included.`
      this.dialog = true
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    }
  }
}
</script>
